module.exports = __webpack_public_path__ + "img/SKMJ_net.066349f2.png";